import { render, staticRenderFns } from "./platinform.vue?vue&type=template&id=1d26cf93&scoped=true&"
import script from "./platinform.vue?vue&type=script&lang=js&"
export * from "./platinform.vue?vue&type=script&lang=js&"
import style0 from "./platinform.vue?vue&type=style&index=0&id=1d26cf93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d26cf93",
  null
  
)

export default component.exports